module.exports = {
	"signin": "Se connecter",
	"signup": "Créer un compte",
	"login": "Identifiant",
	"password": "Mot de passe",
	"confirmPassword": "Confirmer le mot de passe",
	"validate": "Valider",
	"firstname": "Prénom",
	"lastname": "Nom",
	"mobile": "Téléphone mobile",
	"phone": "Téléphone",
	"address": "Adresse",
	"zip": "Code postal",
	"city": "Ville",
	"home": "Accueil",
	"administration": "Administration",
	"administrativeLimits": "Limites administratives",
	"administrativeLimit": "Limite administrative",
	"tutorial": "Didacticiel",
	"signOut": "Déconnexion",
	"connection": "Connexion",
	"legalNotice": "Mentions légales",
	"news": "Actualités",
	"forgotPassword": "Mot de passe oublié ?",
	"needHelp": "Besoin d'aide ?",
	"error": {
		"login": "L'identifiant doit être renseigné",
		"mandatoryTheme": "Vous ne pouvez pas déselectionner ce thême temporairement",
		"password": "Le mot de passe doit être renseigné",
		"confirmPassword": "Le mot de passe de confirmation doit être renseigné",
		"mail": "L'email doit être renseigné",
		"captcha": "Le captcha doit être validé",
		"incorrectEmail": "Adresse e-mail invalide",
		"notFound": "Erreur 404 - Page introuvable",
		"nonexistent": "Station recherchée inexistante",
		"errorDuringExport": "Une erreur est survenue lors de votre export",
		"errorLoadingData": "Erreur lors du chargement des données",
		"noWatershedSelection": "Aucune zone hydrographique trouvée pour cette sélection",
		"pleasePhoneInform": "Merci de renseigner votre téléphone",
		"pleaseNameInform": "Merci de renseigner votre nom",
		"criteriaLimited10": "Nombre de critère limité à 10",
		"radiusLimited20km": "Rayon limité à 20 km",
		"cannotDeleteSite": "Impossible de supprimer vos sites",
		"cannotGetSelection": "Impossible d'obtenir des sélections",
		"cannotSaveInformation": "Impossible d'enregistrer vos informations",
		"errorOccurredExportingSelection": "Une erreur est survenue lors de l'export de votre sélection",
		"errorRequestingCredits": "Une erreur est survenue lors de votre demande de crédits",
		"pleaseFillLeastTheme": "Merci de renseigner au minimum un thème",
		"samePassword": "Les mots de passes ne sont pas identiques",
		"thanksContactSupport": "Merci de contacter le support pour plus d'informations.",
		"notAllowToConnect": "Vous n'êtes pas autorisé à vous connecter.",
		"notRegister": "Vous n'êtes pas renseigné dans notre base de données. Inscrivez-vous !",
		"loginError": "Vous n'êtes pas autorisé à vous connecter"
	},
	"mail": "Adresse e-mail",
	"page": "Page",
	"signupSuccess": "Bienvenue sur AquaDB. Nous vous avons envoyé un mail afin que vous puissiez terminer votre inscription",
	"findEmailSuccess": "Nous vous avons envoyé un mail afin que vous puissiez changer votre mot de passe",
	"name": "Nom",
	"save": "Sauvegarder",
	"success": "Valide",
	"piezometer": "Piézomètre",
	"code": "Code",
	"cityid": "Code commune",
	"nafCode": "Code NAF",
	"icpeScheme": "Régime ICPE",
	"family": "Famille",
	"longitude": "Longitude",
	"longi": "Longitude",
	"zoom": "Zoom",
	"fullScreen": "Plein écran",
	"customZoom": "Zoom personnalisé",
	"latitude": "Latitude",
	"lati": "Latitude",
	"numberOfMeasure": "Nb mesures",
	"firstDate": "Date de début",
	"openingDate": "Date d'ouverture",
	"closingDate": "Date de fermeture",
	"lastDate": "Date de fin",
	"lastMeasure": "Dernière mesure",
	"qualitometer": "Qualitomètre",
	"nbOperation": "Nb operations",
	"nbAnalysis": "Nb analyses",
	"numberAnalysis": "Nombre d'analyses",
	"nbMeasure": "Nb measures",
	"numberMeasure": "Nombre de mesures",
	"surfaceQualitometer": "Qualitomètre de surface",
	"mostDetectedMolecules": "Molécules les plus détectées",
	"pollutedSoil": "Sols pollués",
	"industrialSite": "Sites industriels",
	"siteReseach": "Recherche de sites",
	"stationResearch": "Recherche de points",
	"stationForm": "Fiche station",
	"searchLaunch": "Lancement recherche",
	"advancedSearch": "Recherche avancée",
	"element": "Element",
	"elements": "Elements",
	"lowerOperation": "opération",
	"lowerOperations": "opérations",
	"parameters": "Paramètres",
	"lowerParameter": "paramètre",
	"lowerParameters": "paramètres",
	"quantity": "Quantité",
	"min": "Min",
	"max": "Max",
	"creation": "Création",
	"update": "Mise à jour",
	"restore": "Restaurer",
	"lastExecution": "Dernière éxécution",
	"nbSites": "Nb sites",
	"nbFilters": "Nb filtres",
	"nbThemes": "Nb thèmes",
	"selectYourTheme": "Sélectionner le(les) thème(s) souhaité(s)",
	"town": "Commune",
	"towns": "Communes",
	"watershed": "Masse d'eau",
	"research": "Recherche",
	"researchs": "Recherches",
	"perimeterSearch": "Recherche par périmètre",
	"namePostcodeInsee": "Rechercher en saisissant le nom, le code postal, ou le code INSEE",
	"clickMapDrawCircle": "Cliquez sur la carte et tracez un cercle à partir de ce point",
	"drawShapeAndDoneArea": "Déssiner la forme que vous souhaitez et la recherche s'effectuera dans la zone que vous avez déssinez",
	"uploadKmlAndSearch": "Uploder un KML et la recherche se fera sur ce KML",
	"kmlSearch": "Recherche par KML",
	"citySearch": "Recherche par commune",
	"title": "Titre",
	"filters": "Filtres",
	"selection": "Sélection",
	"selections": "Sélections",
	"site": "Site",
	"filter": "Filtre",
	"station": "Station",
	"stations": "Stations",
	"nbStation": "Stations",
	"themes": "Thèmes",
	"theme": "Thème",
	"map": "Carte",
	"informations": "Informations",
	"myResearch": "Mes recherches",
	"myInformations": "Mes informations",
	"myCredits": "Mes crédits",
	"credits": "Crédits",
	"credit": "Crédit",
	"simpleCredit": "crédit",
	"simplePlurialCredit": "crédits",
	"saveSelectionPlaceholder": "Saisir le titre de la sélection",
	"radius": "Périmètre",
	"drawing": "Dessin",
	"nbFilter": "Nb filtres",
	"nbTheme": "Thèmes",
	"creationDate": "Création",
	"updateDate": "Mise à jour",
	"lastExecutionDate": "Exécution",
	"executionFunction": "Exécuter",
	"deleteFunction": "Supprimer",
	"deleteSelection": "Supprimer la sélection",
	"informationFunction": "Informations",
	"exportFunction": "Exporter",
	"noData": "Pas de données",
	"noSites": "Pas de sites",
	"noNameSelection": "Pas de nom pour cette sélection",
	"analysis": "Analyse",
	"analyses": "Analyses",
	"lowerAnalysis": "analyse",
	"lowerAnalyses": "analyses",
	"measure": "Mesure",
	"measures": "Mesures",
	"measureMin": "mesure",
	"measuresMin": "mesures",
	"sources": "Sources",
	"source": "Source",
	"nbExport": "Nb d'exports",
	"numberExport": "Nombre d'export",
	"lastExport": "Dernier export",
	"dataAvailable": "Données disponibles",
	"sitesAvailable": "Sites disponibles",
	"noDataAvailableQuality": "Qualité - Aucune donnée disponible",
	"isUpdateData": "",
	"export": "Export",
	"exports": "Exports",
	"minute": "minute",
	"seconde": "seconde",
	"secondes": "secondes",
	"selectionCost": "Coût de la sélection",
	"saveSelection": "Enregistrer la sélection",
	"saveTheSelection": "Sauvegarder votre sélection",
	"expiredDownload": "Téléchargement expiré",
	"insufficientCreditExport": "Crédit insuffisant pour l'export",
	"executionTime": "Temps d'exécution",
	"cancel": "Annuler",
	"executeResearch": "Exécuter la recherche",
	"exportSelection": "Exporter la sélection",
	"graphicView": "Vue graphique",
	"cartographicView": "Vue cartographique",
	"nbWatershed": "Zones hydrographiques",
	"watersheds": "Zones hydrographiques",
	"lowerWatersheds": "zones hydrographiques",
	"hydrographicEntity": "Entité hydrographique",
	"annualChart": "Graphique annuel",
	"historicalChart": "Graphique historique",
	"annualAverageLevels": "Niveaux Moyens Annuels",
	"recharge": "Recharger",
	"indicator": "Indicateur",
	"indicatorMin": "indicateur",
	"indicatorsMin": "indicateurs",
	"population": "Population",
	"selectionLoading": "Chargement de vos sélections",
	"uploadingRepositories": "Chargement des référentiels",
	"loadingKeyFigures": "Chargement des chiffres clés",
	"loadingSelectedStations": "Chargement des stations sélectionées",
	"loadingWatershed": "Chargement des zones hydrographiques",
	"loadingCities": "Chargement des communes",
	"loadingStations": "Chargement des stations",
	"loadingYourFilters": "Chargement de vos filtres",
	"status": "Statut",
	"state": "Etat",
	"annualChronicle": "Chronique annuelle",
	"middleChronicle": "Chronique moyenne",
	"envelope": "Enveloppe",
	"fromNetwork": "Emprise",
	"type": "Type",
	"quality": "Qualité",
	"support": "Support",
	"watershedArea": "Zone hydrographique",
	"lowerWatershedArea": "zone hydrographique",
	"point": {
		"denomination": "Dénomination",
		"code": "Code",
		"localization": "Localisation",
		"city": "Commune",
		"network": "Réseaux",
		"watershed": "Zone hydrographique",
		"samplingPoint": "Point de prélèvement",
		"samplingPoints": "Points de prélèvements",
		"coordinate": "Coordonnées",
		"longitude": "Longitude",
		"latitude": "Latitude",
		"altitude": "Altitude",
		"loading": "Chargement de votre point",
		"sheet": "Fiche du point"
	},
	"question": {
		"executeResearch": "Voulez-vous vraiment exécuter cette recherche ?",
		"exportSelection": "Qu'elles informations voulez vous télécharger ?",
		"deleteSelection": "Voulez-vous vraiment supprimer la sélection ?"
	},
	"information": {
		"updateCredit": "Vous devrez recharger votre crédit afin de pouvoir effectuer cette export",
		"contactAddCredit": "Merci de contacter le service commercial AquaDB pour ajouter du crédit",
		"finalCreditAfterExport": "Votre crédit après l'export sera de",
		"successRequestingCredits": "Votre demande de ${ content } crédits à bien été prise en compte"
	},
	"warning": {
		"pleaseMailInform": "Merci de renseigner un email pour votre compte",
		"noSelectionDeletion": "Aucune sélection sélectionnée pour la suppression",
		"noInformationAvailable": "Aucune informations disponibles",
		"noCodeNoticed": "Aucun code remarque",
		"pleaseSiteSelection": "Merci de sélectionner au moins un site",
		"pleaseTitleInform": "Merci de renseigner un titre",
		"pleaseRecreditAccount": "Merci de recréditer votre compte",
		"pleaseFillLeastFilter": "Merci de renseigner au minimum un filtre",
		"noInformationAvailableMunicipalities": "Aucune information disponible sur ces communes",
		"noDataAvailableSite": "Aucune donnée disponible pour ce site",
		"selectionLimit": "Nombre de sélection limité à 5 dans la version Béta"
	},
	"multi": {
		"last": "Dernières",
		"lastMin": "dernières",
		"saved": "enregistrées",
		"your": "Vos"
	},
	"layersAvailable": "Couches cartographiques disponibles",
	"layerAvailable": "Couche cartographique disponible",
	"noLayerAvailable": "Aucune couche cartographique disponible sur ces thèmes",
	"cartographicLayers": "Couches cartographiques",
	"layers": "Couches",
	"siteTypesAvailable": "Types de points disponibles",
	"stationTypes": "Types de points",
	"points": "Points",
	"last": "Dernière",
	"lastMin": "dernière",
	"lowerSelection": "sélection",
	"lowerSelections": "sélections",
	"saved": "enregistrée",
	"accountInformations": "Informations du compte",
	"mapPreferences": "Préférences cartographiques",
	"description": "Description",
	"reference": "Référence",
	"of": "Du",
	"to": "Au",
	"lowerOn": "sur",
	"proximityPoints": "Points à proximité",
	"unknown": "Inconnu",
	"lastUpdate": "Dernière mise à jour",
	"managementWater": "SAGE",
	"ask": "Demander",
	"myAccount": "Mon compte",
	"finish": "Terminer",
	"next": "Suivant",
	"previous": "Précédent",
	"deletedSites": "sites ont bien été supprimés",
	"notYetRegistered": "Pas encore inscrit ?",
	"aquasysCopyright": "@Aquasys",
	"aquasysContact": "contact@aquasys.fr",
	"contactUs": "Nous contacter",
	"aquasys": "Aquasys",
	"aquaDB": "AquaDB",
	"close": "Fermer",
	"activityArea": "Secteur(s) d'activité",
	"notSpecified": "Non renseigné",
	"geographicalCriteriaResearch": "Saisissez le nom ou le code de la zone géographique recherchée",
	"addNewSelection": "Ajouter une sélection",
	"addNewSelectionSuccess": "Votre sélection a bien été ajoutée. Vous recevrez un mail dès que l'ensemble des données sera téléchargé.",
	"receiveEmailDownloadLink": "Vous allez recevoir un mail avec le lien de téléchargement.",
	"savedSelection": "Votre sélection a bien été enregistrée",
	"deletedSelection": "Votre sélection a bien été supprimée",
	"legend": "Légende",
	"defaultLegend": "Légende par défaut",
	"availableCaption": "Légende disponible",
	"availableCaptions": "Légendes disponibles",
	"availablePoint": "Point disponible",
	"availablePoints": "Points disponibles",
	"selectLayerDisplayLegend": "Sélectionner une couche pour afficher la légende correspondante",
	"comment": "Commentaire",
	"dataHistory": "Historique des données",
	"historical": "Historique",
	"distance": "Distance",
	"displayMore": "Afficher plus",
	"availableCredit": "Crédit disponible",
	"availableCredits": "Crédits disponibles",
	"download": "Téléchargement",
	"exportInProgress": "Génération de l'export en cours",
	"inProgress": "En cours",
	"processDevelopment": "En cours de développement",
	"accepted": "J'accepte",
	"stopDisplaying": "Ne plus afficher",
	"selectData": "Sélectionner les points",
	"filterDataByTheme": "Filtrer les points par thème",
	"display": "Afficher",
	"more": "supplémentaire(s)",
	"displayLayers": "Afficher les couches cartographiques",
	"noNewsToDisplay": "Pas d'actualités à afficher",
	"aquadbTitle": "Téléchargez les données open data sur l'eau et l'environnement en 1 clic!",
	"aquadbDevelopedBy": "Un service développé par",
	"cookie": {
		"description": "En continuant votre navigation sur ce site, vous acceptez l’utilisation de cookies pour mesurer l’audience de nos sites et vous proposer du contenu et des publicités ciblées.",
		"more": "En savoir plus et paramétrer les cookies",
		"moreTitle": "Utilisation de cookies dans l'application",
		"communication": "Communication",
		"statistics": "Statistiques",
		"communicationComment": "En contiuant votre navigation sur ce site, vous acceptez l'utilisation de vos informations à des fins de communication interne Aquasys.",
		"statisticsComment": "En contiuant votre navigation sur ce site, vous acceptez l'utilisation de vos informations afin de permettre la génération de statistiques d'utilisation de l'application."
	},
	"selectByHydrologicArea": "Sélectionner par zone hydrographique",
	"selectByPointType": "Sélectionner par type de point",
	"reflate": "Relancer",
	"mySelections": "Mes sélections",
	"advancedResearch": "Recherche avancée",
	"criteriaLimitBeta": "Pour utiliser plus de critères, créez un compte gratuitement.",
	"alreadyRegistered": "Déjà inscrit ?",
	"loginInSuccess": "Bienvenue ",
	"loginOutSuccess": "Déconnexion réalisée avec succès",
	"department": "Département",
	"departments": "Départements",
	"dataSource": "Source de données",
	"cglu": "CGLU",
	"data": "Donnée",
	"datas": "Données",
	"favorite": "Favori",
	"favoriteFunction": "Favori",
	"favoriteResearch": "Recherche favorite",
	"favoriteResearchs": "Recherches favorites",
	"csvExport": "Exporter ma liste de recherche",
	"addCredit": "Ajout de crédits",
	"selectionExportCredit": "Export de la sélection",
	"saveResearch": "Recherche enregistrée",
	"saveResearchs": "Recherches enregistrées",
	"mapGenerate": "Génération de la carte en cours",
	"dataRecuperation": "Récupération des données"
};


//////////////////
// WEBPACK FOOTER
// ./public/i18n/properties.json
// module id = 2218
// module chunks = 0